module.exports = __webpack_public_path__ + "img/nav-icon1.a40cb62b.svg";